module.exports = __webpack_public_path__ + "static/img/nav_logo.5d5e280.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/nav/nav_logo.png
// module id = vUsr
// module chunks = 1